"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconExpandScreen = function IconExpandScreen(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.955 3.36h-4.53a.663.663 0 100 1.326h2.939l-5.281 5.281a.663.663 0 10.928.928l5.281-5.281v2.939a.663.663 0 101.326 0v-4.53a.663.663 0 00-.663-.663zM10.895 12.994a.662.662 0 00-.928.023L4.73 18.364l-.022-2.939a.663.663 0 10-1.326.022l.066 4.53a.663.663 0 00.663.663l4.53-.066a.663.663 0 10-.022-1.326l-2.939.044 5.215-5.347a.664.664 0 000-.95z",
    fill: color
  }));
};

IconExpandScreen.defaultProps = {
  color: 'black',
  size: 30
};
IconExpandScreen.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconExpandScreen;
exports.default = _default;